<template lang="pug">
  .page
    section.section
      h1.headline.page_headline About
        .sub becolomochi について
      h2 べこ 
        small beco
      p.about_paragraph Designer / Frontend developer / Illustrator

    section.section
      h2.section_headline できること

      ul.about_list
        li HTML5/CSS3/JavaScript
        li プログラミングの基礎
        li ターミナル操作
        li 
          a(href="https://twitter.com/becolomochi/status/1021660801982029824" target="_blank") キャラクター制作
        li Adobe Illustrator を使ったイラストやロゴの作成
        li 紙面レイアウト

    section.section
      h2.section_headline 仕事観

      ul.about_list
        li 「あたたかくて やさしい、しなやかなコミュニケーションを」をモットーにし、フリーランスで仕事をしています。
        li 作業は朝（4:00〜7:00ごろ）昼（14:00〜16:00ごろ）しています。
        li Slackやメールは日中も随時対応可能です。
        li 過去に会社員をしながら大学の制作課題をこなしていたこともあり、スケジュールにあわせた作業進行が得意です。
        li 課題に対してどう改善するかを考えて行動することができます。
        li 情報収集を毎日欠かさず行っています。
        li Webサービスが好きで、特にSlackのテキスト／Emojiコミュニケーションが好きです。
        li 本をおすすめされればわりとすぐ買ってしまうほうです。
        li 少人数のチームで実力を出しやすいです。

    section.section
      h2.section_headline 経歴

      h3 2019年

      ul.about_list
        li iOSアプリのLP制作
          ul
            li HTML/Sass(SCSS)
            li GitHub
            li Adobe Illustrator/Figma
        li WebサービスのUI改善
          ul
           li PHP/HTML/Sass(SCSS)
           li GitHub
           li Adobe Illustrator/Figma
        li キャラクター制作
          ul
            li Adobe Illustrator

      h3 2018年

      ul.about_list
        li 2018年4月〜 フリーランス（屋号：べころもち工房）
        li
          a(href="https://creive.me/" target="_blank") creive【クリーブ】
          | さんにて記事公開
        li
          a(href="https://twitter.com/becolomochi/status/1021660801982029824" target="_blank") キャラクター制作
        li アイコン制作
        li レスポンシブサイトコーディング
        li 
          a(href="http://amzn.asia/d/i9PEPqs" target="_blank") ゼロからわかる Ruby 超入門（技術評論社）イラストを担当

      h3 〜2017年

      ul.about_list
        li 群馬高専卒業
        li 印刷会社にDTPオペレータとして勤務（2009〜2015）
          ul
            li 折込チラシ・名刺・封筒・DMなど各種印刷物のデザイン
            li 印刷用完全データの作成
            li WordPressのカスタマイズ・コーディング
        li Web システム開発会社へ（2015〜2017）
          ul
            li システムのUI改修
            li Webデザイン・コーディング
            li ロゴデザイン
        li 京都造形芸術大学 通信教育部 情報デザインコース卒業（2011〜2016）

    section.section
      h2.section_headline 好きなもの

      ul.about_list
        li ダム
        li 生き物（特に犬、猫、ジンベエザメ、アロワナ）
        li 自然
        li ゆるキャラ
        li 音楽（ジャズ・テクノ・ポップス）

    section.section
      h2.section_headline 関連リンク

      ul.about_list
        li
          a(href="https://booth.pm/ja/items/667217") BOOTH Vue.jsでポートフォリオサイト制作記
          br
          | このポートフォリオサイトの作り方について書いた技術系同人誌です
        li
          a(href="https://becolomochi.tumblr.com") Tumblr
          br
          | イラストやグッズの紹介など
        li
          a(href="https://becolomochi.hatenablog.com") ブログ
        li
          a(href="https://scrapbox.io/becolomochi") Scrapbox
        li
          a(href="https://github.com/becolomochi") GitHub
        li
          a(href="https://twitter.com/becolomochi") Twitter
        li
          a(href="https://www.instagram.com/becolomochi") Instagram
        li
          a(href="http://booklog.jp/users/becolomochi") Booklog
        li
          a(href="http://qiita.com/becolomochi") Qiita
        li
          a(href="https://suzuri.jp/becolomochi") グッズ販売
        li
          a(href="https://store.line.me/stickershop/product/1018430") LINEスタンプ
</template>

<script>
  export default {
    title: 'About',
    description: 'べこ（becolomochi）の経歴・仕事観・性格・好きなものについて書いたページです。'
  }
</script>



// WEBPACK FOOTER //
// About.vue?09404004